import appConfig from '@/lib/appConfig';

export default function() {
  const headers = {
    'X-Api-Key': appConfig.nrel_client_side_api_key,
  }

  // In production, the api.data.gov layer will add the X-Api-Roles header based
  // on the API key used. But when not going through this layer (dev, test,
  // non-main staging), then fake the roles that would be set.
  if (appConfig.rails_env !== 'production') {
    if (!appConfig.api_url_root.startsWith('https://developer.nlr.gov') && !appConfig.api_url_root.startsWith('https://devstage.nlr.gov')) {
      headers['X-Api-Roles'] = 'nrel-afdc-vehicles-msrp';
    }
  }

  return headers;
}
